// extracted by mini-css-extract-plugin
export default {"ruleInlineHightlight":"styles_ruleInlineHightlight_VHH24"};